import { Chip, Tooltip } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

import mainTheme from "@aclymatepackages/themes";
import { CategoriesAvatar } from "@aclymatepackages/atoms";
import findSubcategory from "@aclymatepackages/subcategories";
import { truncateText } from "@aclymatepackages/other-helpers";

const VendorCategoryChip = ({
  emissionCategory,
  naicsTitle = "Uncategorized Vendor",
  truncateLength,
}) => {
  const { name: categoryName, color } = findSubcategory(emissionCategory) || {};

  const TEXT_TRUNCATE_LENGTH = truncateLength || 20;

  return (
    <Tooltip
      disableHoverListener={naicsTitle?.length <= TEXT_TRUNCATE_LENGTH}
      title={naicsTitle}
    >
      <span>
        <Chip
          style={{
            backgroundColor: emissionCategory
              ? color
              : mainTheme.palette.error.main,
            color: "white",
          }}
          avatar={
            emissionCategory ? (
              <CategoriesAvatar subcategory={emissionCategory} size="small" />
            ) : undefined
          }
          icon={
            !emissionCategory ? (
              <ErrorIcon style={{ color: "white" }} />
            ) : undefined
          }
          label={
            !emissionCategory
              ? "Uncategorized Vendor"
              : emissionCategory === "spend-based"
              ? truncateText(naicsTitle, TEXT_TRUNCATE_LENGTH)
              : categoryName
          }
        />
      </span>
    </Tooltip>
  );
};
export default VendorCategoryChip;
